import { sortSponsors, type SponsorAd } from '@/domain/sponsors'

export interface SponsorSlot { key: string; ad: SponsorAd | null }
export interface SponsorRow { items: SponsorSlot[]; slotWidthRem: number }

export const SPONSOR_GAP_REM = .75
export const SPONSOR_SEATS_PER_GROUP = 3
export const SPONSOR_TWO_COLUMN_MIN_REM = 35.75
export const SPONSOR_THREE_COLUMN_MIN_REM = 54

/** Complete groups of three seats before wrapping to three, two or one columns. */
export function layoutSponsors(ads: readonly SponsorAd[], widthRem: number): SponsorRow[] {
  if (!ads.length || !Number.isFinite(widthRem) || widthRem <= 0) return []
  const columns = widthRem >= SPONSOR_THREE_COLUMN_MIN_REM ? 3 : widthRem >= SPONSOR_TWO_COLUMN_MIN_REM ? 2 : 1
  const slotWidthRem = (widthRem - (columns - 1) * SPONSOR_GAP_REM) / columns
  const items: SponsorSlot[] = sortSponsors(ads).map(ad => ({ key: `ad:${ad.id}`, ad }))
  while (items.length % SPONSOR_SEATS_PER_GROUP) items.push({ key: `vacancy:${items.length}`, ad: null })
  const rows: SponsorRow[] = []
  for (let index = 0; index < items.length; index += columns) {
    rows.push({ items: items.slice(index, index + columns), slotWidthRem })
  }
  return rows
}

export function sponsorHref(href: string | undefined): string | undefined {
  if (!href) return undefined
  try {
    const url = new URL(href)
    return ['https:', 'http:'].includes(url.protocol) ? url.href : undefined
  } catch { return undefined }
}
